<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.HWC.EVS.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:hwc:relationalVolumeServiceResourceHwc:update'
          ]"
          :loading="updateLoading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:hwc:relationalVolumeServiceResourceHwc:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <elastic-cloud-disk-hwc-search
      ref="child"
    ></elastic-cloud-disk-hwc-search>
    <table-elastic-cloud-disk-hwc></table-elastic-cloud-disk-hwc>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import ElasticCloudDiskHwcSearch from "./ElasticCloudDiskHwcSearch.vue";
import TableElasticCloudDiskHwc from "./TableElasticCloudDiskHwc.vue";
import Export from "../../hwc/Export";
let tableElasticCloudDiskHwc = TableElasticCloudDiskHwc;

export default {
  name: "ElasticComputeCloudResourceHwc",
  components: {
    ElasticCloudDiskHwcSearch,
    TableElasticCloudDiskHwc,
    Export
  },
  data() {
    return {
      modal_loading: false,
      updateLoading: false,
      companyId: ""
    };
  },
  methods: {
    update() {
      this.updateLoading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountSearchKey,
          resourceManagement: 3,
          accountType: 5
        })
        .then(res => {
          this.updateLoading = false;
          tableElasticCloudDiskHwc.methods.showAll();
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList() {
      let exportDTO = {
        companyId: this.$refs.child.companyId,
        accountIds: this.$refs.child.accountSearchKey,
        accountName: this.$refs.child.accountName,
        volumeAwsId: this.$refs.child.volumeAwsId
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      //下载Excel文件
      this.$api.resourceManagement.exportHWCVolume(exportDTO).then(res => {
        this.exportResponse(res);
      });
    },
    exportResponse(res) {
      let fileName = "云磁盘.xls";
      let blob = new Blob([res.data], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
      this.modal_loading = false;
      this.$Message.destroy();
      this.$Message.success("导出成功");
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/hwc/evs/ElasticCloudDiskHwc.vue